import {
  LegalPageContainerStyle,
  legalPageSpacing
} from 'src/components/watchAndWin/LegalPagesStyles';

const PrivacyPolicy = () => {
  return (
    <section css={LegalPageContainerStyle}>
      <div style={{ color: 'white' }}>
        <p css={legalPageSpacing}>
          <b>Introduction</b>
          <b></b>
        </p>
        <p>
          Welcome to <b>Jalwa </b>
          <b>Dikhao</b>
          <b> Dubai Jao</b>
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Jalwa </b>
          <b>Dikhao</b>
          <b> Dubai Jao</b> is a contest (“Contest”) organized by Zee
          Entertainment Enterprises Limited. The Contest is being conducted only
          for Indian citizens who are residing in India at the time of
          conducting this Contest and must be aged 18 years and above. By means
          of the Contest, the Company is providing an opportunity to win daily
          gratification and travel to Dubai as per the Terms and Conditions of
          the Contest. To know more:{' '}
          <a href="https://www.zee5.com/gamification/watchandwin/termsofuse">
            https://www.zee5.com/gamification/watchandwin/termsofuse
          </a>
          .
        </p>
        <p></p>
        <p>
          Zee Entertainment Enterprises Limited (&quot;we&quot;, &quot;us&quot;,
          &quot;Company&quot;) values the trust placed in us by data subject
          (&quot;you&quot;, &quot;your&quot;, “participant”) and therefore, we
          follow the highest standards of privacy guidelines to protect the
          information shared by you with us.
        </p>
        <p></p>
        <p>
          This Privacy Notice (&quot;Privacy Notice&quot;) governs the use of
          Personal Information shared (as defined below) with or collected by
          Company from the participants of the Contest in India. The Company is
          the “Data Fiduciary” for the personal data discussed in this Privacy
          Notice. This Privacy Notice explains our practices, including your
          choices, regarding the collection, use, and disclosure of certain
          information, including your personal information in connection with
          the Contest.
        </p>
        <p></p>
        <p>
          For the purposes of this Privacy Notice references have been made to
          the Information Technology Act, 2000 and the Digital Personal Data
          Protection Act, 2023 governing data protection in India, and all other
          applicable privacy laws.
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Objective & Scope</b>
        </p>
        <p>This notice applies to Participants of the Contest etc.</p>
        <p>
          A “Participant” refers to an individual who is person participating in
          the Contest and has willingly submitted their Personal Data to the
          Company.{' '}
        </p>
        <p>
          This Notice applies to Personal Data/Information, as defined below,
          that we collect to provide you with certain products and services,
          including the opportunity to enrol/participate in the Contest
          (collectively, “Services”). This Notice does not apply to anonymized,
          de-identified or aggregate information if it is not Personal
          Information.
        </p>
        <p css={legalPageSpacing}>
          <b>Personal Data </b>
          <b>(</b>
          <b>P</b>
          <b>ersonally </b>
          <b>I</b>
          <b>dentifiable </b>
          <b>I</b>
          <b>nformation</b>
          <b>-PII</b>
          <b>) </b>-
        </p>
        <p>
          In line with applicable privacy regulations, the Company has
          classified all information relating to an identified or identifiable
          natural person which by itself or when clubbed with other information
          available can be used to identify a natural person or is associated
          with a consumer or household. The Company as a part of its business
          operations routinely handles various categories of personal data of
          its Users/Visitors. Such information is processed on a regular basis
          either directly by the Company or through third parties.
        </p>
        <p css={legalPageSpacing}>
          <b>User Consent</b>
          <b></b>
        </p>
        <p>
          By participating in the Contest, you agree to provide consent to our
          collection, use and sharing of your Personal Data as described in this
          Privacy Notice as well as the Privacy Notice of Zee5. (Add the Zee5
          Privacy link)
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Consent and Legal Basis</b>
        </p>
        <p>
          By logging into Zee5 web/application or by participating in the
          Contest through a missed call, you consent to collection and
          processing of your personal data as outlined in this Privacy Notice.
          This data processing is essential to fulfil the purpose of the
          Contest. If you have not indicated that you do not consent to the use,
          we will assume that you consent to us processing the data for these
          purposes. This may include using your contact information to notify
          you about Contest outcomes or reach out to you for follow ups and
          further information.
        </p>
        <p css={legalPageSpacing}>
          <b>Information collected </b>
          <b>from</b>
          <b> you:</b>
        </p>
        <p>Information you provide directly:</p>
        <p>
          When you participate in the Contest, or when you fill out the contact
          us form, or enter a contract with us for certain services, access, or
          features, , we may ask you to provide certain personal data such as
          the following:{' '}
        </p>
        <ol style={{ padding: '20px 50px' }}>
          <li>First and Last Name;</li>
          <li>Date of Birth;</li>
          <li>Age;</li>
          <li>Gender;</li>
          <li>Contact number;</li>
          <li>Alternate contact number;</li>
          <li>Location;</li>
          <li>Email address;</li>
          <li>Full residential address;</li>
          <li>Masked Aadhaar as the address proof;</li>
          <li>Copy of first & last pages of the Passport, if applicable;</li>
          <li>
            Colour passport size photo in a format as prescribed by the Dubai
            Visa consulate, if applicable;
          </li>
          <li>PAN Card, if applicable;</li>
          <li>Full vaccination certificate, if applicable.</li>
        </ol>
        <p></p>
        <p>
          You agree to provide complete and correct information with respect to
          the above and such other information as may be required by the
          Company. You further agree to provide only such information which
          belongs to you and that does not infringe any third part rights,
          including, without limitation any third-party privacy rights.{' '}
        </p>
        <p css={legalPageSpacing}>
          <b>How We Utilize Information collected from You:</b>
          <b> </b>
        </p>
        <p css={legalPageSpacing}>
          <b>General:</b> The Company may employ the information gathered to
          provide a Service, fulfil a requested service, or feature, and provide
          recommendations from your use of our Services in addition to
          contacting you for the purposes of the Contest, contingent upon your
          prior consent or permissive regulations.
        </p>
        <p css={legalPageSpacing}>
          <b>Contest</b>
          <b> Administration: </b>Your information may be utilized by the
          Company to manage the Contest, record entries and verify eligibility.
          In case of winners of the Contest, their names and location will be
          published on-air as a squeeze-ups (Astons) and on Zee5 application in
          the ILT20 section as per Terms and Conditions of the Contest.
        </p>
        <p css={legalPageSpacing}>
          <b>Safety & Fraud Prevention</b>: Your data may be used for fraud
          prevention purposes, including but not limited to monitoring
          transactions, detecting suspicious activities, and ensuring services
          remain secure and protected.
        </p>
        <p css={legalPageSpacing}>
          <b>Legal Compliance</b>: Data may be used to ensure compliance with
          legal requirements/ regulations (such as tax laws) in relation to
          Contest participation or other legal obligations.
        </p>
        <p css={legalPageSpacing}>
          <b>Third Party Partnerships</b>: If the company collaborates with
          third parties, sponsors, partners, advertisers, data may be shared
          with third parties, to smoothly facilitate the execution of this
          Contest.
        </p>
        <p css={legalPageSpacing}>
          <b>Disclosure to Third Parties: </b>
        </p>
        <p>
          We do not share your information with any other third-parties, unless
          expressly provided herein below:
        </p>
        <p css={legalPageSpacing}>
          <b>The ZEE Family of Companies: </b>
        </p>
        <p>
          We share your information among the ZEE family of companies as needed
          for providing you with access to our services; providing customer
          support; making decisions about service improvements; content
          development; and for other purposes described in the How We Utilize
          Information collected from You section of this Privacy Notice.{' '}
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Legal</b>
        </p>
        <p></p>
        <p>
          In the event of any requirement by court order, government, or
          quasi-government agency to disclose your Personal Data, we will
          disclose information as may be legally required. We may also disclose
          your Personal Data if we, in good faith believe that such disclosure
          is reasonably necessary to respond to subpoenas, court orders, or
          other legal process.
        </p>
        <p></p>
        <p>
          In the event Company is merged with or acquired by another company,
          you acknowledge that we and our affiliates may share your Personal
          Data, wholly or in part, with another business entity.
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Service Providers: </b>
        </p>
        <p>
          We may share / disclose your information with service providers for
          the purposes of conducting the Contest. All service providers
          receiving such information are required to enter into Data Processing
          Agreements with us.{' '}
        </p>
        <p></p>
        <p css={legalPageSpacing}>
          <b>Your Control & Choices:</b>
        </p>
        <p>
          We provide you the ability to exercise certain controls and choices
          regarding our collection and/or use and sharing of your Personal Data.
          In accordance with applicable law, your controls and choices may
          include:
        </p>
        <ul style={{ padding: '10px 50px' }}>
          <li css={legalPageSpacing}>
            <b>Access of Data</b>: You can ask us for a summary of personal data
            which is being processed by us and the processing activities
            undertaken by us with respect to such personal data; the identities
            of all other Data Fiduciaries and Data Processors with whom the
            personal data has been shared by us, along with a description of the
            personal data so shared by sending us an e-mail at dpo@zee.com.
          </li>
          <li css={legalPageSpacing}>
            <b>Rectification of inaccurate or incomplete information</b>: You
            can ask us to correct inaccurate or incomplete Personal Data
            concerning you (this is the information which you cannot update
            yourself within your account/dashboard) by sending us an e-mail at
            dpo@zee.com.
          </li>
          <li css={legalPageSpacing}>
            <b>Right to Grievance Redressal</b>: If you require any information
            or clarification regarding the use of your Personal Data or this
            Privacy Notice or if you have any grievances with respect to use of
            your Personal Data, please email us at dpo@zee.com.
          </li>
          <li css={legalPageSpacing}>
            <b>Data Retention and Erasure</b>: We retain your Personal Data
            until the completion of the Contest and further for a period of 2
            years from the date of receipt of such data in accordance with the
            Terms and Conditions for the Contest. This is required for the
            performance of the contract between you and us and to comply with
            our legal obligations. If you no longer want us to use your
            information, then you can request that we erase your Personal Data
            and close your account. Please note that upon your request for the
            erasure of your Personal Data, we may still need to:
            <ul>
              <li>
                Retain some of your Personal Data as necessary for our
                legitimate business interests, such as fraud detection and
                prevention and enhancing safety. For example, if we suspend an
                account for fraud or safety reasons, we may retain certain
                information from that account to prevent that user from opening
                a new account in the future.
              </li>
              <li>
                Retain and use your Personal Data to the extent necessary to
                comply with our legal obligations. For example, we may keep some
                of your information for tax, legal reporting, and auditing
                obligations.
              </li>
            </ul>
          </li>
          <li css={legalPageSpacing}>
            <b>Withdrawing Consent</b>: Where consent is the legal basis for
            processing the data, you have the right to withdraw your consent.
            For withdrawing your consent at any time during your tenure with us,
            you may choose to do so by sending us an e-mail at dpo@zee.com. We
            shall review your request and may ask you to verify your identity.
            Post verification we will withdraw the consent for which request was
            made by you and stop any further processing of your Personal Data,
            for purposes that relied on consent.
          </li>
          <li>
            Company is committed to complying with the <b>Do Not Call (DNC)</b>{' '}
            provisions. We may send marketing messages to your country&apos;s
            telephone number if you have given us consent, OR you have not
            registered with the national DNC Registry, OR the sending of such
            messages is permissible under applicable laws and regulations.
          </li>
          <li>
            Please note that after opting out, you may continue to receive
            non-marketing messages, such as product updates and service Notices
            as permitted under applicable local laws and regulations.
          </li>
        </ul>

        <p css={legalPageSpacing}>
          <b>Children&apos;s Privacy</b>
        </p>
        <p>
          Our services are intentionally not designed for or directed at persons
          less than 18 years of age. Company does not knowingly permit any
          person who is under 18 years of age to register with the services or
          to provide any other personally identifying information. If Company
          becomes aware that any PII of persons less than 18 years of age has
          been collected by the Company without verified parental consent, then
          Company will take the appropriate steps to delete any such information
          and notify the parent. Should a parent or guardian have reasons to
          believe that a minor has provided company with Personal Data without
          their prior consent, please contact our customer support team to
          ensure that the Personal Data of the child is removed from the
          Company.
        </p>

        <p css={legalPageSpacing}>
          <b>Security and Compliance</b>
        </p>
        <ul style={{ padding: '10px 50px' }}>
          <li>
            We are continuously implementing and updating administrative,
            technical, and physical security measures to help protect your
            information against unauthorized access, loss, destruction, or
            alteration. Some of the safeguards we use to protect your
            information are firewalls and data encryption, and information
            access controls. If you know or have reason to believe that your
            account credentials have been lost, stolen, altered, or otherwise
            compromised or in case of any actual or suspected unauthorized use
            of your account, please contact us by contacting our customer
            support team.
          </li>
          <li>We design our systems with your security and privacy in mind.</li>
          <li>
            We work to protect the security of your Personal Data during
            transmission by using encryption protocols and software.
          </li>
          <li>
            We only onboard payment gateways as partners who are Payment Card
            Industry Data Security Standard (PCI DSS) or equivalent certified.
          </li>
          <li>
            We maintain physical, electronic, and procedural safeguards in
            connection with the collection, storage, and disclosure of personal
            customer information. Our security procedures mean that we may ask
            you to verify your identity before we disclose Personal Data to you.
          </li>
          <li>
            Our devices offer security features to protect them against
            unauthorized access and loss of data. Our Platform resorts to
            Two-Way Authentication via E-Mail/Phone as a Technical Measure to
            safeguard the access.
          </li>
        </ul>
        <p>
          The security of your information is important to us. We use a variety
          of physical, technical, and administrative measures to safeguard
          information in our possession against loss, theft and unauthorized
          use, disclosure, and modification. We use measures like encryption and
          hashing to help protect Personal Data when in transmission and in
          storage.
        </p>
        <p css={legalPageSpacing}>
          <b>Changes to this Privacy </b>
          <b>Notice</b>
        </p>
        <p>
          The Company may periodically update this Privacy Notice to reflect any
          changes in the processing of your Personal Data. Where material
          changes are made to this Privacy Notice, we will post a prominent
          Notice on our Website indicating that we have updated the Privacy
          Notice and will indicate at the top of the Privacy Notice when it was
          last updated. You are requested to check our website periodically for
          such updates. If you access our Services after a Notice of change has
          been published on our page, you hereby provide us your consent to the
          changed terms.
        </p>
        <p css={legalPageSpacing}>
          <b>Dispute Resolution</b>
        </p>
        <p>
          The Company welcomes your comments regarding this Privacy Notice. If
          you believe that we have not adhered to this Privacy Notice, you may
          convey the same to us by contacting us in the manner mentioned below.
          In your email, please describe in as much detail as possible ways in
          which you believe the Privacy Notice has not been complied with. In
          addition to the foregoing, any disputes arising under this Privacy
          Notice shall be governed by the laws/provisions of India.
        </p>
        <p css={legalPageSpacing}>
          <b>Contact Us</b>
        </p>
        <p>dpo@zee.com</p>
        <p css={legalPageSpacing}>
          <b>Address for receiving </b>
          <b>Notice</b>
          <b>s:</b>
        </p>
        <p>ZEE Entertainment Enterprises Limited,</p>
        <p>8th Floor, A Wing, Marathon Futurex,</p>
        <p>N M Joshi Marg, Lower Parel,</p>
        <p>Mumbai – 400013</p>
        <p></p>
        <p>
          <b>Privacy Notice Last Updated</b> - 03/01/2025
        </p>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
